/**
 * 회사 담당자 테이블 아이템 형태 정의
 * 서버 응답을 테이블에서 사용할 수 있는 형태로 변환하기 위한 구조 정의
 */

/**
 * 테이블에서 사용하는 회사 담당자 아이템의 필드 구조
 */
export const COMPANY_MANAGER_TABLE_ITEM_SCHEMA = Object.freeze({
  id: null,                    // number - 담당자 ID
  name: null,                  // string - 담당자명
  company: null,               // Object - 회사 정보
  siteRelations: null,         // Array - 사이트 관계 배열
  phone: null,                  // string - 전화번호
  email: null                  // string - 이메일
});

/**
 * 서버 응답 데이터를 테이블 아이템 형태로 변환하는 함수
 * @param {Object} serverItem - 서버에서 받은 담당자 객체
 * @returns {Object} 테이블에서 사용할 수 있는 형태의 아이템 객체
 */
export function transformToCompanyManagerTableItem(serverItem) {
  if (!serverItem) {
    return null;
  }

  return {
    id: serverItem?.id ?? null,
    name: serverItem?.name ?? null,
    company: serverItem?.company ?? null,
    siteRelations: serverItem?.siteRelations ?? [],
    phone: serverItem?.phone ?? '-',
    email: serverItem?.email ?? '-'
  };
}

/**
 * 서버 응답 배열을 테이블 아이템 배열로 일괄 변환하는 함수
 * @param {Array<Object>} serverItems - 서버에서 받은 담당자 객체 배열
 * @returns {Array<Object>} 테이블에서 사용할 수 있는 형태의 아이템 객체 배열
 */
export function transformToCompanyManagerTableItems(serverItems) {
  if (!Array.isArray(serverItems)) {
    return [];
  }

  return serverItems
    .map(item => transformToCompanyManagerTableItem(item))
    .filter(item => item !== null);
}

